<template>
  <div>
    <div id="waveButton"></div>
    <v-carousel cycle height="500" hide-delimiter-background show-arrows-on-hover>
      <v-carousel-item
        v-for="(item, i) in $t('carousel.features')"
        :key="i"
        style="align-itens: center"
      >
        <v-sheet color="#001E4A" height="100%">
          <v-row class="fill-height" align="center" justify="center">
            <v-col
              cols="12"
              sm="6"
              lg="6"
              class="d-block justify-center"
              style="background-color: white; border-radius: 20px; margin: 10px"
            >
              <p style="color: #BD1C2C; text-align: center; font-size: 14px">
                {{ item.preTitle }}
              </p>
              <h2 style="color: black; text-align: center; font-size: 14px">
                {{ item.title }}
              </h2>
              <p style="color: black; margin: 10px; text-align: center; font-size: 14px">
                {{ item.description }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
    <div id="waveTop"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      colors: ['primary'],
      model: 0,
    };
  },

  components: {},

  mounted() {},
};
</script>

<style>
#waveTop {
  position: relative;
  height: 90px;
  width: '100%';
  background: #001e4a;
}
#waveTop:after {
  content: '';
  display: block;
  border-radius: 100% 100% 0% 0%;
  width: '120%';
  height: 90px;
  background-color: white;
  right: -5px;
  transform: rotate(0deg);
}
</style>
